import { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ROUTES } from './routes/config';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import {
  AuthProvider,
  PasswordProtection,
} from './features/password-protection';

// Styles
import './styles/colors.css';

function App() {
  const { i18n } = useTranslation();
  const HomeComponent = ROUTES.MAIN[0].component;

  return (
    <>
      <Helmet>
        <html lang={i18n.language} />
        <meta name='language' content={i18n.language} />
      </Helmet>
      <AuthProvider>
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
            <div>
              <Routes>
                {/* Main Routes */}
                {ROUTES.MAIN.map(({ path, component: Component }) => (
                  <Route key={path} path={path} element={<Component />} />
                ))}

                {/* Blogs Routes */}
                <Route path={ROUTES.BLOGS.ROOT}>
                  <Route index element={<HomeComponent />} />
                  {ROUTES.BLOGS.ROUTES.map(({ path, component: Component }) => (
                    <Route key={path} path={`:slug`} element={<Component />} />
                  ))}
                </Route>

                {/* Tools Routes - Protected */}
                <Route path={ROUTES.TOOLS.ROOT}>
                  <Route
                    index
                    element={
                      <PasswordProtection>
                        <HomeComponent />
                      </PasswordProtection>
                    }
                  />
                  {ROUTES.TOOLS.ROUTES.map(({ path, component: Component }) => (
                    <Route
                      key={path}
                      path={path}
                      element={
                        <PasswordProtection>
                          <Component />
                        </PasswordProtection>
                      }
                    />
                  ))}
                </Route>

                {/* Dashboard Routes - Protected */}
                <Route path={ROUTES.DASHBOARD.ROOT}>
                  <Route
                    index
                    element={
                      <PasswordProtection>
                        <HomeComponent />
                      </PasswordProtection>
                    }
                  />
                  {ROUTES.DASHBOARD.ROUTES.map(
                    ({ path, component: Component }) => (
                      <Route
                        key={path}
                        path={path}
                        element={
                          <PasswordProtection>
                            <Component />
                          </PasswordProtection>
                        }
                      />
                    )
                  )}
                </Route>

                {/* Career Quest Routes - Protected */}
                <Route path={ROUTES.CAREER_QUEST.ROOT}>
                  <Route
                    index
                    element={
                      <PasswordProtection>
                        <HomeComponent />
                      </PasswordProtection>
                    }
                  />
                  {ROUTES.CAREER_QUEST.ROUTES.map(
                    ({ path, component: Component }) => (
                      <Route
                        key={path}
                        path={path}
                        element={
                          <PasswordProtection>
                            <Component />
                          </PasswordProtection>
                        }
                      />
                    )
                  )}
                </Route>

                {/* Dashboard menu item routes - Protected and redirect to dashboard/home */}
                <Route
                  path='/teacher-resources'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/create'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/support'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/profile'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/schedule'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/students'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/files'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />
                <Route
                  path='/settings'
                  element={
                    <PasswordProtection>
                      <HomeComponent />
                    </PasswordProtection>
                  }
                />

                {/* Catch all route */}
                <Route path='*' element={<HomeComponent />} />
              </Routes>
            </div>
          </Suspense>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
